<template>
  <div class="form-container userform-container">
    <h1>利用者の表示</h1>
    <form>
      <table class="info-table">
        <tbody>
          <tr>
            <td><strong>都道府県</strong></td>
            <td><strong>:</strong></td>
            <td>{{ region_id + " " +  userInfo.region }}</td>
          </tr>
          <tr>
            <td><strong>行政機関</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.group }}</td>
          </tr>
          <tr>
            <td><strong>利用者ID</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.id }}</td>
          </tr>
          <tr>
            <td><strong>利用者氏名（漢字）</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.nameKanji }}</td>
          </tr>
          <tr>
            <td><strong>利用者氏名（カナ）</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.nameKana }}</td>
          </tr>
          <tr>
            <td><strong>利用者区分</strong></td>
            <td><strong>:</strong></td>
            <td>{{ section_id }}</td>
          </tr>

          <tr>
            <td><strong>部署名</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.departName }}</td>
          </tr>
          <tr>
            <td><strong>備考</strong></td>
            <td><strong>:</strong></td>
            <td>{{ userInfo.addNote }}</td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;
import "@/assets/styles/User.css";

export default {
  data() {
    return {
      userInfo: {
        region: "",
		group: "",
        id: "",
        departName: "",
        mail: "",
        nameKanji: "",
        nameKana: "",
        zip: "",
        zyuusho1: "",
        zyuusho2: "",
        birth: "",
        sex: "",
        tell: "",
        mobile: "",
        addNote: "",
		section: "",
      },
	  section_id: "",
	  region_id: "",
    };
  },
  mounted() {
    //this.region_id = localStorage.getItem('regionId');
  },
  methods: {
    formatGender(data) {
      switch (data) {
        case "0":
          return "不明";
        case "1":
          return "男性";
        case "2":
          return "女性";
        default:
          return "";
      }
    },
    formatDate(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月は0始まり
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}年${month}月${day}日`;
    },
    async getUserDetails() {
	  var fin = false;
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/getDetail`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.userInfo = response.data.data;
		  this.userInfo.group = response.data.data.gyouseiName;
		  switch (this.userInfo.section) {
			case "0000" : this.section_id="システム管理者"; break;
			case "0100" : this.section_id="行政機関管理者"; break;
			case "0101" : this.section_id="行政機関メンバー"; break;
			case "0201" : this.section_id="捕獲者"; break;
			case "0210" : this.section_id="見える化管理者"; break;
			case "0211" : this.section_id="見える化メンバー"; break;
			default : this.section_id=""; break;
		  }
        } else {
		  // dead code
          alert("不明なエラーです");
        }
		fin = true;
      } catch (error) {
		if (error.response.status==401) {
          alert("タイムアウトです、ログインしなおしてください");
          this.$router.push({ name: 'Login' });
		} else if (error.response) {
          alert(`サーバーエラー（${error.response.status}）`);
		} else {
          alert("ネットワークエラー：" + error);
		}
		fin = true;
      } finally {
		if(!fin) {
          alert("接続を確認してください");
		}
	  }
    },
  },
  mounted() {
    this.getUserDetails();
  },
};
</script>

<style scoped>
form {
  border: 2px solid #ccc;
  border-radius: 8px;
  font-size: 16px;
  max-height: 100vh;
  overflow-y: auto;
}
</style>
